import React, { useState, useEffect } from "react";
import Modal from "../../components/Modal/Modal";
import EditDriver from "../../components/DriverComponents/Editdriver";
const DriverSalaryInfo = ({ driver }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [salaryInfo, setSalaryInfo] = useState({});

  useEffect(() => {
    if (driver?.driverSalaryInfo) {
      setSalaryInfo(driver.driverSalaryInfo);
    }
  }, [driver]);

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  return (
    <>
      <div className="driver-salary-header">
        <h2 style={{ margin: 0 }}>Salary and Allowances</h2>
        <button className="custom-button" onClick={toggleModal}>
          Edit Salary Info
        </button>
      </div>
      <div className="driver-salary-info">
        <div>
          <span className="driver-salary-label">Name:</span> {driver.firstName}{" "}
          {driver.lastName}
        </div>
        <div>
          <span className="driver-salary-label">Phone:</span> {driver.phone}
        </div>
        <div>
          <span className="driver-salary-label">Salary Type:</span>{" "}
          {salaryInfo.salaryType || "N/A"}
        </div>
        <div>
          <span className="driver-salary-label">Salary:</span>{" "}
          <span className="driver-salary-amount">
            ₹{salaryInfo.salary || 0}
          </span>
        </div>
      </div>
      <div className="driver-salary-allowances-title">Allowances</div>
      <div className="driver-salary-grid">
        <div className="driver-salary-grid-item">
          <span className="driver-salary-label">Daily Wage:</span> ₹
          {salaryInfo.daily_wage || 0}
        </div>
        <div className="driver-salary-grid-item">
          <span className="driver-salary-label">Overtime/hr:</span> ₹
          {salaryInfo.overtime_per_hour || 0}
        </div>
        <div className="driver-salary-grid-item">
          <span className="driver-salary-label">Morning Allowance:</span> ₹
          {salaryInfo.morning_allowance || 0}
        </div>
        <div className="driver-salary-grid-item">
          <span className="driver-salary-label">Night Allowance:</span> ₹
          {salaryInfo.night_allowance || 0}
        </div>
        <div className="driver-salary-grid-item">
          <span className="driver-salary-label">Outstation Allowance:</span> ₹
          {salaryInfo.outstation_allowance || 0}
        </div>
        <div className="driver-salary-grid-item">
          <span className="driver-salary-label">Outstation Morning:</span> ₹
          {salaryInfo.outstation_morning_allowance || 0}
        </div>
        <div className="driver-salary-grid-item">
          <span className="driver-salary-label">Sunday Allowance:</span> ₹
          {salaryInfo.sunday_allowance || 0}
        </div>
        <div className="driver-salary-grid-item">
          <span className="driver-salary-label">Daily Allowance:</span> ₹
          {salaryInfo.daily_allowance || 0}
        </div>
      </div>
      {isModalOpen && (
        <Modal isOpen={true} onClose={toggleModal} title="Edit Salary Info">
          <EditDriver 
            driverId={driver.id} 
            onlySalaryInfo={true}
            toggleModal={toggleModal}
          />
        </Modal>
      )}
    </>
  );
};

export default DriverSalaryInfo;
